import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Add16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.75 7.25V1H7.25V7.25H1V8.75H7.25V15H8.75V8.75H15V7.25H8.75Z'
      fill='currentColor'
    />
  </Svg>
);

Add16.displayName = 'Add16';
export default Add16;
